import React, { Component } from "react";
import { Link } from 'react-router-dom';
import { Button, FormGroup, Label, Input, FormFeedback } from "reactstrap";
import backlogo from '../../../assets/images/svg/Back.svg'
import { setRegistrationEmail } from "../../../reducers/counterSlice";
import { connect } from 'react-redux';
import Loader from "react-loaders";
import axiosInstance from "../../configuration/Request";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const mapStateToProps = (state) => {

  return {
    value: state.counterSlice.value
  };
};

const mapDispatchToProps = {
  setRegistrationEmail
};
class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      createAccountEmail: '',
      isValidEmail: true,
      errorMessage: '',
      loader: false,
      agreedToTerms: false,
      showAgreementModal: false,
      activeTab: null,
      agreements: [],
      agreementLoader: false,
      agreementError: '',
    };
  }

  fetchAgreements = () => {
    this.setState({ agreementLoader: true, agreementError: '' });
    axiosInstance
      .get(process.env.REACT_APP_BASE_URL + 'api/user-agreement/active')
      .then((res) => {
        const agreements = res?.data?.data?.agreement ?? [];
        this.setState({ agreements, agreementLoader: false });
      })
      .catch(() => {
        this.setState({ agreementError: 'Failed to load agreements. Please try again.', agreementLoader: false });
      });
  };

  openAgreementModal = (tabTitle) => {
    this.setState({ showAgreementModal: true, activeTab: tabTitle }, () => {
      this.fetchAgreements();
    });
  };

  closeAgreementModal = () => {
    this.setState({ showAgreementModal: false, activeTab: null });
  };

  handleAgree = () => {
    this.setState({ agreedToTerms: true, showAgreementModal: false, activeTab: null });
  };

  authenticationCreate = () => {

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex?.test(this.state?.createAccountEmail)) {

      this.setState({ isValidEmail: true });
      this.setState({ loader: true });
      axiosInstance.get(process.env.REACT_APP_BASE_URL + `api/users?filters[email][$eq]l=${this.state?.createAccountEmail}`)
        .then((res) => {
          if (res?.data?.length > 0) {
            this.setState({ errorMessage: 'This email address is already registered. Please try signing in or use a different email address to register.' })
          } else {
            this.setState({ errorMessage: '' });
            this.otpAPICallFn();
          }
        })
        .catch((err) => {
          console.error(" error:", err);
          this.setState({ errorMessage: 'Something went wrong.Please try after sometime.' });
        })
        .finally(() => {
          this.setState({ loader: false });
        });
    } else {
      this.setState({ isValidEmail: false });
    }



  };


  otpAPICallFn = () => {

    this.setState({ loader: true });
    axiosInstance
      .post(process.env.REACT_APP_BASE_URL + "api/otps", {
        "data": {
          "email": this.state.createAccountEmail ?? ''
        }
      })
      .then((res) => {
        this.setState({ otpSent: true })
        this.props.setRegistrationEmail(this.state.createAccountEmail ?? '');
        this.props.history.push('/auth/otpVerify');
      })
      .catch((err) => {
        console.error(" error:", err);
        this.setState({ errorMessage: 'Something went wrong.Please try after sometime.' });
      })
      .finally(() => {
        this.setState({ loader: false })
      });
  }


  handleEmailChange = (e) => {
    this.setState({ createAccountEmail: e.target.value });
  };



  render() {
    const { otpSent, errorMessage, agreedToTerms, showAgreementModal, activeTab, agreements, agreementLoader, agreementError } = this.state;

    // Map API titles to our three tab keys
    const TAB_KEYS = [
      { key: 'Terms & Conditions', label: 'Terms & Conditions' },
      { key: 'Privacy Policy', label: 'Privacy Policy' },
      { key: 'Cookie Policy', label: 'Cookies Policy' },
    ];

    const activeAgreement = agreements.find(
      (a) => a.title?.toLowerCase().includes(activeTab?.toLowerCase()?.split(' ')?.[0] ?? '')
    ) ?? agreements[0];

    return (
      <>
        <div className=''>
          <Link className='btn-link-primary'
            to={{ pathname: '/auth/login' }}>
            <div className="d-inline-flex gap-2" >
              <img src={backlogo} alt="" />
              <span className="back-text">Back</span>
            </div>
          </Link>
          <h4 className="mb-0">
            <div className="login-text">{'Create an Account'}</div>
          </h4>

          <h6 className="my-2 login-subtext">
            Or{" "}
            <Link className='text-primary-link' to={{ pathname: '/auth/login' }}>
              Login
            </Link>
          </h6>

          <div style={{ maxWidth: '24rem' }}>
            <FormGroup floating>
              <Input type="email" name="email" id="exampleEmail" placeholder="Email" disabled={otpSent}
                value={this.state.createAccountEmail} onChange={this.handleEmailChange} invalid={!this.state.isValidEmail}
              />
              <Label for="exampleEmail">Email</Label>
              <FormFeedback>Please enter a valid email address.</FormFeedback>
            </FormGroup>

            {/* Terms Checkbox */}
            <div className="register-terms-row">
              <input
                type="checkbox"
                id="agreeTermsCheckbox"
                checked={agreedToTerms}
                onChange={(e) => this.setState({ agreedToTerms: e.target.checked })}
                className="register-terms-checkbox"
              />
              <label htmlFor="agreeTermsCheckbox" className="register-terms-label">
                By continuing, you agree to the{' '}
                <span className="register-terms-link" onClick={() => this.openAgreementModal('Terms & Conditions')}>User Agreement</span>,{' '}and{' '}
                <span className="register-terms-link" onClick={() => this.openAgreementModal('Privacy Policy')}>Privacy Policy</span>
              </label>
            </div>

            <div className="login-button mt-3">
              {errorMessage &&
                <div className="error-msg-display">{errorMessage}</div>
              }
              <Button
                size="lg" color="primary" className="w-100"
                onClick={this.authenticationCreate}
                disabled={!this.state.createAccountEmail || !agreedToTerms}
              >
                Create Account
              </Button>
            </div>
          </div>
        </div>

        {/* Agreement Modal */}
        {showAgreementModal && (
          <div className="agreement-modal-overlay" onClick={this.closeAgreementModal}>
            <div className="agreement-modal-box" onClick={(e) => e.stopPropagation()}>
              {/* Modal Header */}
              <div className="agreement-modal-header">
                <div>
                  <div className="agreement-modal-title">Registration policies</div>
                </div>
                <button className="agreement-modal-close" onClick={this.closeAgreementModal} aria-label="Close">&#x2715;</button>
              </div>

              {/* Tabs */}
              <div className="agreement-modal-tabs">
                {TAB_KEYS.map((tab) => (
                  <button
                    key={tab.key}
                    className={`agreement-tab-btn${activeTab === tab.key ? ' active' : ''}`}
                    onClick={() => this.setState({ activeTab: tab.key })}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>

              {/* Modal Body */}
              <div className="agreement-modal-body">
                {agreementLoader && (
                  <div className="agreement-modal-loading">
                    <Loader type="ball-pulse-rise" />
                  </div>
                )}
                {agreementError && !agreementLoader && (
                  <div className="agreement-modal-error">{agreementError}</div>
                )}
                {!agreementLoader && !agreementError && (() => {
                  // Find matching agreement for active tab
                  const tabKeyMap = {
                    'Terms & Conditions': ['terms'],
                    'Privacy Policy': ['privacy'],
                    'Cookie Policy': ['cookie'],
                  };
                  const keywords = tabKeyMap[activeTab] ?? [];
                  const found = agreements.find((a) =>
                    keywords.some((kw) => a.title?.toLowerCase().includes(kw))
                  );
                  if (!found) return <div className="agreement-modal-empty">No content available.</div>;
                  return (
                    <div className="agreement-markdown-content">
                      <ReactMarkdown remarkPlugins={[remarkGfm]}>{found.content}</ReactMarkdown>
                    </div>
                  );
                })()}
              </div>

              {/* Modal Footer */}
              {/* <div className="agreement-modal-footer">
                <button className="agreement-btn-close" onClick={this.closeAgreementModal}>Close</button>
                <button className="agreement-btn-agree" onClick={this.handleAgree}>I Understand</button>
              </div> */}
            </div>
          </div>
        )}

        {this.state.loader &&
          <div className="backdrop">
            <div className="loader">
              <Loader type="ball-pulse-rise" />
            </div>
          </div>
        }
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Register);

